import { stats } from "@/mocks/home";

export default function StatBand() {
  return (
    <section className="relative overflow-hidden bg-accent-500">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col">
              <div className="flex items-baseline font-heading text-3xl md:text-5xl font-black text-foreground-950">
                <span className="tabular-nums">{s.value}</span>
                <span className="ml-1 text-xl md:text-2xl font-bold">{s.unit}</span>
              </div>
              <div className="mt-1 text-xs md:text-sm text-foreground-900/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}